import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient, type UseMutationOptions} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

import {REFRACTORIES_WITH_CUSTOMIZATION_QUERY_KEY} from '../consts'
import type {ErrorResponse} from '../types'

interface UpdateRefractoryCustomizationVariables {
  plantUpmId: string
  refractoryId: number
  color: string | null
}

export const useUpdateRefractoryCustomization = (
  options?: Omit<
    UseMutationOptions<void, AxiosError<ErrorResponse>, UpdateRefractoryCustomizationVariables>,
    'mutationFn'
  >
) => {
  const queryClient = useQueryClient()

  return useMutation<void, AxiosError<ErrorResponse>, UpdateRefractoryCustomizationVariables>({
    mutationFn: async ({
      plantUpmId,
      refractoryId,
      color
    }: UpdateRefractoryCustomizationVariables) => {
      await ApiClient.axiosInstance.patch<void>(
        `/plants/${plantUpmId}/refractory-product-data-catalog/refractories/${refractoryId}/customization`,
        {color}
      )
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === REFRACTORIES_WITH_CUSTOMIZATION_QUERY_KEY
      })
      await options?.onSuccess?.(...args)
    }
  })
}
